import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconDeleteSvg } from "./IconDeleteSvg.mjs";
const IconDelete = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconDeleteSvg, ...svgProps }) });
export {
  IconDelete
};
